<!-- 
  动态Tab页组件
  根据客户类型配置动态渲染Tab页内容
  支持客户类型差异化显示
-->
<template>
  <div class="dynamic-tab-page">
    <a-spin :spinning="loading">
      <dynamic-tab-content
        v-if="tabConfig && customerData"
        :tabConfig="tabConfig"
        :customerData="customerData"
      />
      <a-empty v-else description="暂无配置或数据" />
    </a-spin>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, PropType, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import { DynamicTabContent } from './ComponentFactory';
// import { CustomerTypeDefinition } from '@/services/customer-type-metadata.js';
// import customerTypeMetadataService from '@/services/customer-type-metadata.js';

export default defineComponent({
  name: 'DynamicTabPage',
  components: {
    DynamicTabContent
  },
  props: {
    tabId: {
      type: String,
      required: true
    },
    customerId: {
      type: String,
      required: true
    },
    customerType: {
      type: String,
      required: true
    },
    customerData: {
      type: Object as PropType<any>,
      default: () => ({})
    }
  },
  setup(props) {
    const route = useRoute();
    const loading = ref(false);
    // const typeConfig = ref<CustomerTypeDefinition | null>(null);
    const typeConfig = ref<any>(null);
    const tabConfig = computed(() => {
      // 简化版配置，直接使用传入的数据
      return {
        id: props.tabId,
        components: []
      };
    });
    
    // 加载客户类型配置
    const loadTypeConfig = async () => {
      if (!props.customerType) return;
      
      loading.value = true;
      try {
        // 模拟加载配置
        console.log(`加载客户类型配置: ${props.customerType}, Tab: ${props.tabId}`);
        
        // 简化处理，忽略实际加载
        // const config = await customerTypeMetadataService.getCustomerTypeDetail(...)
        
        typeConfig.value = {
          id: props.customerType,
          name: props.customerType,
          uiConfig: {
            tabs: [{
              id: props.tabId,
              components: []
            }]
          }
        };
      } catch (error) {
        console.error('加载客户类型配置失败:', error);
        message.error('加载页面配置失败，请刷新重试');
      } finally {
        loading.value = false;
      }
    };
    
    // 监听客户类型变化
    watch(() => props.customerType, () => {
      loadTypeConfig();
    });
    
    onMounted(() => {
      loadTypeConfig();
    });
    
    return {
      loading,
      tabConfig
    };
  }
});
</script>

<style scoped>
.dynamic-tab-page {
  padding: 16px;
  background-color: #f0f2f5;
  min-height: 400px;
}
</style> 